module.exports = __webpack_public_path__ + "static/media/fulizhognxin.a440d865.jpg";